<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Nova exportação"
    >
        <Form
            @saved="handleExit"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
                color="secondary"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                Gerar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        handleExit() {
            this.$emit('save')
            this.$refs.RkmModal.hide()
        },
    },
}
</script>